import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import AppointmentPreference from '../AppointmentPreference'

const AppointmentPreferencePage = () => {
   const { data: user, isLoading } = useAuthUser({ revalidateOnMount: true })
   if (isLoading) return null
   return (
      <div className="flex flex-col flex-1 h-full overflow-hidden">
         <div className="flex items-center justify-between h-20 pl-8 pr-4 bg-white/5 shrink-0">
            <span className="text-lg font-medium">Appointment Preference</span>
         </div>
         <div className="flex-1 overflow-y-auto">
            <div className="px-8 pt-6">
               <AppointmentPreference email={user?.email || ''} />
            </div>
         </div>
      </div>
   )
}

export default AppointmentPreferencePage
